import { DockItemURIParams } from '../../models';

export class DockOverviewLoad {
  public static readonly type = '[DockOverview] Load';
  constructor(public payload: DockItemURIParams) {}
}

export class DockOverviewClone {
  public static readonly type = '[DockOverview] Clone';
  constructor(public payload: DockItemURIParams) {}
}

export class DockOverviewInitialState {
  public static readonly type = '[DockOverview] Set Initial State';
}
